import axiosInstance from "../../components/api/axiosInstance";

/** Id from POST /create-test-case response (shape varies). */
export function extractCreatedTestCaseId(data, depth = 0) {
  if (data == null || typeof data !== "object" || depth > 4) return null;
  const raw =
    data.Test_Case_Id ??
    data.test_case_id ??
    data.TestCaseId ??
    data.testCaseId ??
    data.id ??
    data.ID;
  const n = Number(raw);
  if (Number.isFinite(n) && n > 0) return n;
  const inner = data.data ?? data.test_case ?? data.result;
  if (inner != null && inner !== data) {
    const nested = extractCreatedTestCaseId(inner, depth + 1);
    if (nested != null) return nested;
  }
  return null;
}

export async function createTestCase(payload) {
  const response = await axiosInstance.post("/create-test-case", payload);
  return response.data?.data ?? response.data;
}

/**
 * Fetch test cases from GET /test-cases
 * Supports: task_id, sub_task_id (API params)
 * testCaseId and status are filtered client-side if provided
 */
export async function fetchTestCases({ taskId, subTaskId, testCaseId, status } = {}) {
  const params = {};
  if (taskId != null && taskId !== "" && Number.isFinite(Number(taskId))) params.task_id = Number(taskId);
  if (subTaskId != null && subTaskId !== "" && Number.isFinite(Number(subTaskId))) params.sub_task_id = Number(subTaskId);

  try {
    const response = await axiosInstance.get("/test-cases", { params });
    const raw = response.data;
    const arr = Array.isArray(raw)
      ? raw
      : Array.isArray(raw?.data)
        ? raw.data
        : Array.isArray(raw?.test_cases)
          ? raw.test_cases
          : [];
    return Array.isArray(arr) ? arr : [];
  } catch (err) {
    // Fallback endpoint naming
    if (err?.response?.status === 404) {
      const response = await axiosInstance.get("/testcases", { params });
      const raw = response.data;
      const arr = Array.isArray(raw)
        ? raw
        : Array.isArray(raw?.data)
          ? raw.data
          : Array.isArray(raw?.test_cases)
            ? raw.test_cases
            : [];
      return Array.isArray(arr) ? arr : [];
    }
    throw err;
  }
}

/**
 * Fetch a single test case by ID.
 * GET /test-case/:id
 */
export async function fetchTestCaseById(testCaseId) {
  if (testCaseId == null || testCaseId === "" || !Number.isFinite(Number(testCaseId))) return null;
  const response = await axiosInstance.get(`/test-case/${Number(testCaseId)}`);
  return response.data?.data ?? response.data;
}

/**
 * Update a test case.
 * PUT /update-test-case/:id
 * Payload: Task_Id, Sub_Task_Id, Title, Description, Pre_Conditions, Steps,
 * Expected_Result, Actual_Result, Status, Comments, Executed_By
 */
export async function updateTestCase(testCaseId, payload) {
  if (testCaseId == null || testCaseId === "" || !Number.isFinite(Number(testCaseId))) {
    throw new Error("Invalid test case ID");
  }
  const response = await axiosInstance.put(`/update-test-case/${Number(testCaseId)}`, payload);
  return response.data?.data ?? response.data;
}

/**
 * Delete a test case.
 * DELETE /delete-test-case/:id
 */
export async function deleteTestCase(testCaseId) {
  if (testCaseId == null || testCaseId === "" || !Number.isFinite(Number(testCaseId))) {
    throw new Error("Invalid test case ID");
  }
  const response = await axiosInstance.delete(`/delete-test-case/${Number(testCaseId)}`);
  return response.data;
}

